



















import { getContentArea } from '@/contentful';
import {
  LoadingService,
  ExtendMixins,
} from '@/services';
import { EventBus } from '@/event-bus';
import { PageIntro, PageSidebar } from '@/components/page-components';
import { ProviderListing } from '@/components/account-settings-components/personal-settings-components';
import { OpenAddProviderScreen } from '@/mixins/get-content-mixins';
import { CTA } from '@/@types/member';
import { DataTableRefs } from '@/constants';

interface Data {
  dataTableRef: string;
  sidebarHeading: string;
  sidebarContent: string;
  ctaConfig: CTA;
}

export default ExtendMixins(
  OpenAddProviderScreen,
).extend({
  name: 'Providers',
  beforeRouteEnter(to, from, next) {
    LoadingService.watchPromises(getContentArea('providers-sidebar-content'))
      .then((data) => {
        const sidebar = data[0];
        if (sidebar && sidebar.fields) {
          to.meta.sidebarHeading = sidebar.fields.headline;
          to.meta.sidebarContent = sidebar.fields.content;
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  async beforeRouteLeave(to, from, next) {
     await this.$store.dispatch('destroyTableInstanceByRefName', this.dataTableRef);
     next();
  },
  data(): Data {
    return {
      dataTableRef: DataTableRefs.providers,
      sidebarHeading: this.$route.meta.sidebarHeading,
      sidebarContent: this.$route.meta.sidebarContent,
      ctaConfig: {
        text: this.$options.filters.t([
          'providers_action_add-provider',
          'global_add-provider',
        ]),
        action: () => {
          this.openAddProviderScreen({ dataTableRef: DataTableRefs.providers });
        },
      },
    };
  },
  components: {
    ProviderListing,
    PageIntro,
    PageSidebar,
  },
});
